import WebLayout from './EmailPreviewLayout.web';
import MobileLayout from './EmailPreviewLayout.mobile';
import { isReactNative } from 'ui-builder';

export default isReactNative() ? MobileLayout : WebLayout;
